import { Collapse, Form } from 'react-bootstrap';
import { Button, Label } from '../../atoms';
import React, { FC, useState } from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '../../../assets/icons/svg';
import cn from 'classnames';
import styles from './UploadIndicatorDocumentOrganism.module.css';
import { FileMeta } from '../../../store/mediaAPI/document/dto/request/document-save-request';
import { FileUploader } from '../../molecules';

interface UploadDocumentProps {
  setFile: (file: string) => void;
  setFileMeta?: (fileMeta: FileMeta) => void;
  name?: string;
  setName: (name: string) => void;
  description?: string;
  setDescription: (description: string) => void;
  date?: string;
  setDate: (date: string) => void;
  callbackFn: () => void;
}

const UploadDocument: FC<UploadDocumentProps> = ({
  setFile,
  setFileMeta,
  name,
  setName,
  description,
  setDescription,
  date,
  setDate,
  callbackFn,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [localFile, setLocalFile] = useState<string>();
  const [localName, setLocalName] = useState<string | undefined>(name);

  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    callbackFn();
  };

  return (
    <>
      <div className={cn(styles.uploadDocumentWrapper)}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          onClick={() => setOpen(!open)}
        >
          <Label
            style={{ padding: '.5rem 0' }}
            content="Upload Document"
            size="heading-md"
          />
          {open ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </div>
        <Collapse in={open}>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>FileName</Form.Label>
              <FileUploader
                setFile={(file: string) => {
                  setFile(file);
                  setLocalFile(file);
                }}
                setFileMeta={(fileMeta) => {
                  if (setFileMeta) {
                    setFileMeta(fileMeta);
                  }
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Document name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document name"
                onChange={(e) => {
                  setName(e.target.value);
                  setLocalName(e.target.value);
                }}
                value={name}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Document Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document description"
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                value={description}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Document Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Enter document date"
                onChange={(e) => {
                  setDate(e.target.value);
                }}
                value={date}
              />
            </Form.Group>
            <Button
              onClick={handleSubmit}
              variant="light"
              disabled={!localName || !localFile}
            >
              Upload document
            </Button>
          </Form>
        </Collapse>
      </div>
    </>
  );
};

export default UploadDocument;
